define([
    'WebCommon/event-bus',
    'WebCommon/events',
    'vue'
], function(
    EventBus,
    Events,
    Vue
){
    var cdnOrigin = 'http://static-test.fnji.com';
    var imageOrigin = getImageOrigin();

    function ln2br(str){
        return (str||'').replace(/\n/g,'<br/>');
    }
    function genFnjiImageUrl(imageName){
        return imageName ? imageOrigin + '/temp/upload/' + imageName : '';
    }


    function genCdnImageUrl(imageName){
        return imageName ? cdnOrigin + '/temp/upload/'+imageName : '';
    }
    function scrollToSelector(selector, options){
        var $selector = $(selector);


        if (!$selector.length) return;


        if (options === 0) {
            $selector[0].scrollIntoView();
        } else {

            var top = $selector.offset().top;
            scrollTo(top, options);
        }
    }
    function dealImageName(name){
        return (name||'').replace('s20480_', '');
    }

    function getImageOrigin(){
        switch(window.location.hostname){
            case 'e.fnjitest.com':
            case 'm.e.fnjitest.com':
                return 'http://e.fnji.com';
            case 'fnji.com':
            case 'www.fnji.com':
            case 'm.fnji.com':
                return cdnOrigin;
            default:
                return '';
        }
    }

    function emitPageReady(){
        EventBus.$emit(Events.PageReady);
    }

    function getUrlKey(name)
    {

        return decodeURIComponent((new RegExp('[?|&]'+name+'='+'([^&;]+?)(&|#|;|$)').exec(location.href)||[,""])[1].replace(/\+/g,'%20'))||null;

    }



    return {
        scrollToSelector:scrollToSelector,
        ln2br: ln2br,
        genFnjiImageUrl: genFnjiImageUrl,
        genCdnImageUrl: genCdnImageUrl,
        emitPageReady: emitPageReady,
        getUrlKey: getUrlKey
    };
});


//////////////////
// WEBPACK FOOTER
// ./common/utils.js
// module id = 16
// module chunks = 0 1 2 3 4 5 6 7 8